module.exports = __webpack_public_path__ + "static/Ecommerce-e2464b0ef5bb70865a3e07e113ce44a7.svg";